import { useEffect } from "react";
import { proxy, useSnapshot } from "valtio";

// Export authState so it can be used outside of React components
export const authState = proxy({data:{  }})

const useAuth = () => {
const snap = useSnapshot(authState)
    const Auth = snap.data

    useEffect(() => {
        //      console.log('Auth:', Auth)
    }, [Auth])

    const setAuth = (obj) => {
        authState.data = obj
    }


    return { Auth, setAuth }
}

export default useAuth;
